import { render } from "./UserTestsComponent.vue?vue&type=template&id=47e90f85&scoped=true&lang=html"
import script from "./UserTestsComponent.vue?vue&type=script&lang=js"
export * from "./UserTestsComponent.vue?vue&type=script&lang=js"

import "./UserTestsComponent.vue?vue&type=style&index=0&id=47e90f85&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-47e90f85"

export default script